module.exports = __webpack_public_path__ + "static/media/refresh.ed43546b.png";